import { render } from "./InputCheckbox.vue?vue&type=template&id=6d93c0bc"
import script from "./InputCheckbox.vue?vue&type=script&lang=js"
export * from "./InputCheckbox.vue?vue&type=script&lang=js"

import "./InputCheckbox.vue?vue&type=style&index=0&id=6d93c0bc&lang=scss"

import exportComponent from "/var/www/recruitment-form-front-end-master/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__